import { render, staticRenderFns } from "./PopupProductDatesItem.vue?vue&type=template&id=29c32882&"
import script from "./PopupProductDatesItem.vue?vue&type=script&lang=ts&"
export * from "./PopupProductDatesItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports